// @flow

import { kebabCase } from 'lodash/string'

export function searchInOptions (query: string, options: Array<Object>): Array<Object> {
  const normalizedQuery = kebabCase(query)

  return options.filter((option: Object) => kebabCase(option.title).includes(normalizedQuery))
}
